import { CLIENT_SETTINGS } from 'constants/clientSettings'
import DOMAIN from 'constants/domains'
import React from 'react'
import { getDomain ,isKsDomain ,isSaficDomain} from 'utils/domain'

import { IconProps } from './Icon'
import TrackingIcon from './TrackingIcon'

/**
 * 要請者の車アイコン
 */
const RequesterIcon: React.FC<IconProps> = (props) => {
  const color = isKsDomain() ? 'var(--color-modal-background)' : isSaficDomain() ? 'var(--color-icon-car)' :{
    [DOMAIN.SJ]: 'var(--color-modal-background)',
  }[getDomain()]

  return (
    <TrackingIcon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="55"
        height="55"
        viewBox="0 0 55 55"
      >
        <defs>
          <filter
            id="RequesterIconFilter"
            x="0"
            y="0"
            width="55"
            height="55"
            filterUnits="userSpaceOnUse"
          >
            <feGaussianBlur stdDeviation="3" result="b" />
            <feFlood floodOpacity="0.239" />
            <feComposite operator="in" in2="b" />
            <feComposite in="SourceGraphic" />
          </filter>
        </defs>
        <g transform="translate(11 11)">
          <g
            transform="matrix(1, 0, 0, 1, -11, -11)"
            filter="url(#RequesterIconFilter)"
          >
            <g
              transform="translate(11 11)"
              fill={color}
              stroke={CLIENT_SETTINGS.colors.textForMainBackground}
              strokeWidth="2"
            >
              <rect width="33" height="33" rx="7" stroke="none" />
              <rect x="-1" y="-1" width="35" height="35" rx="8" fill="none" />
            </g>
          </g>
          <path
            d="M17.593,5.926A1.37,1.37,0,0,0,16.292,5H6.208a1.378,1.378,0,0,0-1.3.926L3,11.417V18.75a.919.919,0,0,0,.917.917h.917a.919.919,0,0,0,.917-.917v-.917h11v.917a.919.919,0,0,0,.917.917h.917a.919.919,0,0,0,.917-.917V11.417ZM6.208,15.083a1.375,1.375,0,1,1,1.375-1.375A1.373,1.373,0,0,1,6.208,15.083Zm10.083,0a1.375,1.375,0,1,1,1.375-1.375A1.373,1.373,0,0,1,16.292,15.083ZM4.833,10.5,6.208,6.375H16.292L17.667,10.5Z"
            transform="translate(5.25 4.428)"
            fill={CLIENT_SETTINGS.colors.textForMainBackground}
          />
          <path
            d="M4,0,8,7H0Z"
            transform="translate(20.255 39.817) rotate(180)"
            fill={color}
          />
        </g>
      </svg>
    </TrackingIcon>
  )
}

export default RequesterIcon
